import { render } from "./CommonAuthorFour.vue?vue&type=template&id=9f342916&scoped=true"
import script from "./CommonAuthorFour.vue?vue&type=script&lang=js"
export * from "./CommonAuthorFour.vue?vue&type=script&lang=js"

import "./CommonAuthorFour.vue?vue&type=style&index=0&id=9f342916&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f342916"]])

export default __exports__